import { ReactNode } from 'react'

import { FeedbackEnum } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export enum AIBannerTheme {
  light = 'light',
  dark = 'dark',
  lightDashed = 'light-dashed',
  darkDashed = 'dark-dashed',
}

export interface AIActions {
  id: string
  userId?: string
  aiRatingResponseTooltip?: ReactNode
  createdAtContent?: string
  infoContent?: ReactNode
  initialRating?: FeedbackEnum
  onOpenDetails?: VoidFunction
  onChangeRating?: (id: string, feedback: FeedbackEnum) => void
}
